// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"30b2e4c5","499":"ce18551b"}[chunkId] + ".chunk.js";
};